import ActionTypes from "../constants/action-types";
import store from "../reducers/reducer";


export const setFreeLinksIsBusy = (payload) => (dispatch) => {
    dispatch({
        type: ActionTypes.SET_FREE_TRIAL_IS_BUSY,
        payload
    });
};
export const getFreeLinks = () => async (dispatch) => {

    dispatch({
        type: ActionTypes.SET_FREE_TRIAL_IS_BUSY,
        payload: true,
    });

    await axios.get('/api/get-free-trial-links')
        .then((response) => {
            dispatch({
                type: ActionTypes.SET_FREE_TRIAL_PROMOTIONS,
                payload: response.data.links,
            });
        })
        .catch((error) => {
            console.log('error getting free trial links');
        })
        .finally(() => {
            dispatch({
                type: ActionTypes.SET_FREE_TRIAL_IS_BUSY,
                payload: false,
            });
        });
};

export const deleteFreeLinks = (link) => (dispatch) => {

    dispatch({
        type: ActionTypes.SET_FREE_TRIAL_IS_BUSY,
        payload: true,
    });

    axios.delete(`/api/free-trial-links/${link}`)
        .then((response) => {
            dispatch(getFreeLinks());
        })
        .catch((error) => {
            console.log('error deleting free trial link');
        })
        .finally(() => {
            dispatch({
                type: ActionTypes.SET_FREE_TRIAL_IS_BUSY,
                payload: false,
            });
        });
};

export const setFreeTrials = (payload) => {
    return {
        type: ActionTypes.SET_FREE_TRIAL_PROMOTIONS,
        payload
    };
};

export const refetchPromotion = payload => ({
    type: ActionTypes.REFETCH_PROMOTIONS,
    payload
});